import DispatcherEvent from '@carvana/merch-native/DispatcherEvent';
import React, { useCallback } from 'react';
import { useIsNative } from '~/context/common/DeviceContext';
import { useSendMessageToNative } from '~/context/common/NativeContext';
import { type PurchaseEventPayload } from '~/native/common/contracts';

export default function useSourcedHandleNativePurchaseOnClick() {
  const isNative = useIsNative();
  const sendMessageToNative = useSendMessageToNative();

  return useCallback(
    (
      event: React.MouseEvent<HTMLElement>,
      nativePayload: PurchaseEventPayload
    ) => {
      if (!isNative) return;

      event.preventDefault();

      sendMessageToNative(DispatcherEvent.ContinuePurchase, nativePayload);
    },
    [isNative, sendMessageToNative]
  );
}
